"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductGroupPage = exports.default = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _base = babelHelpers.interopRequireWildcard(require("block/base"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _CatalogGroupPage = require("CatalogGroupPage");

var _CatalogGroup = require("pages/CatalogGroup");

var _Cart = babelHelpers.interopRequireDefault(require("Cart"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp, _dec, _dec2, _class3, _descriptor9, _descriptor10, _descriptor11, _temp2;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var ProductGroup = (_dec = (0, _decorators.alias)("content.type"), _dec2 = (0, _decorators.alias)("content.name"), (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(ProductGroup, _Component2);

  function ProductGroup() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, ProductGroup);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(ProductGroup)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "type", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "name", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(ProductGroup, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(ProductGroupPage, this.content);
    }
  }]);
  return ProductGroup;
}(_react.Component), _temp2), (_descriptor9 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3));
exports.default = ProductGroup;
var ProductGroupPage = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(ProductGroupPage, _Component);

  function ProductGroupPage() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, ProductGroupPage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(ProductGroupPage)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "background", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "id", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "spotlight", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "subHeadline", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "headline", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "summary", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "catalogGroup", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "footerBlocks", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(ProductGroupPage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        id: "page-content-container"
      }, _react.default.createElement("div", {
        className: _classList.default.join('block', 'stack', 'header-block', 'height-50vh', this.background && 'variable-background'),
        "data-landing-page-group": this.id,
        "data-block-type": "header",
        style: this.background ? _base.default.styleForBackgroundObject(this.background) : {}
      }, _react.default.createElement("div", {
        className: "spotlight-header"
      }, this.spotlight && _react.default.createElement(_CatalogGroup.SpotlightCarousel, this.spotlight), _react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, this.subHeadline && _react.default.createElement("h2", null, this.subHeadline), _react.default.createElement("h1", {
        className: "title"
      }, this.headline), this.summary && _react.default.createElement(Fragment, null, _react.default.createElement("hr", null), _react.default.createElement("p", {
        style: {
          whiteSpace: 'pre-wrap'
        }
      }, this.summary))))), _react.default.createElement("div", {
        className: "block stack height-auto"
      }, _react.default.createElement("div", {
        id: "catalogGroupPage"
      }, _react.default.createElement(_CatalogGroupPage.CatalogGroupPage, _extends({
        className: "stack catalog-group product-group"
      }, this.catalogGroup)))), _react.default.createElement(require(this.footerBlocks.child_type).default, this.footerBlocks));
    }
  }]);
  return ProductGroupPage;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "background", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "id", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "spotlight", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "subHeadline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "headline", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "catalogGroup", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "footerBlocks", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.ProductGroupPage = ProductGroupPage;